export default __webpack_public_path__ + "img/2a9cf8c46b1da230b83cb28df6d8c89e.png";